import { Button, ButtonGroup, PrimaryButton } from "@nulogy/components";
import React from "react";

export default function ModalFormButtons({ formId, onClose, disabled, pendoTagClass }) {
  return (
    <ButtonGroup className="spec-modal-form-buttons">
      <PrimaryButton className={pendoTagClass} disabled={disabled} form={formId} type="submit">
        Save
      </PrimaryButton>
      <Button onClick={onClose}>Cancel</Button>
    </ButtonGroup>
  );
}
